import plannerContactPersonImageSrc from '../assets/ContactPersonImage/planner.jpeg'
import {PLANT_ID} from '../consts'
import plants from '../plants.json'
import {AppConfig, PlantId} from '../types'

const whiteListedPlants: PlantId[] = Object.keys(plants)

export const planner: AppConfig = {
  contact: {
    name: 'Daniil Starikov',
    mail: 'daniil.starikov@heidelbergmaterials.com',
    profileImage: plannerContactPersonImageSrc
  },
  name: 'Planner',
  url: {
    qa: `https://planner-qa.hproduce.digital/plants/${PLANT_ID}`,
    uat: `https://planner-uat.hproduce.digital/plants/${PLANT_ID}`,
    prod: `https://planner.hproduce.digital/plants/${PLANT_ID}`
  },
  whiteListedPermissionTypes: ['VIEW_ELECTRICITY_PRICE'],
  plant: {
    whiteList: whiteListedPlants
  }
}
